<template>
  <div class="container">
    <div class="info">
      <!-- 标题 -->
      <div class="title">{{ $t('property').IncomeDetails }}</div>
      <!-- 列表 -->
      <div class="listInfo">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`po${dIndex}`">
          <div class="name"> {{ dItem.productName }} <span class="amount red" v-if="dItem.profitAmount < 0">-${{
            -dItem.profitAmount }}</span>
            <span class="amount green" v-else>+${{ dItem.profitAmount }}</span>
          </div>
          <div class="time">{{ dItem.createTime | getLocalTime }} <span>-</span> <span>{{ dItem.salesTime | getLocalTime
              }}</span></div>
          <div class="order" v-if="dItem.orderNo">{{ dItem.orderNo }} <span @click="onCopy(dItem.orderNo)">{{
            $t('public').copyTxt }}</span>
          </div>
        </div>
        <!-- 分页 -->
        <div class="pagefoot">
          <el-pagination :current-page="parms.pageNum" :page-size="parms.pageSize" layout="prev, pager, next"
            hide-on-single-page :total="total" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import orderApi from '@/api/order'
export default {
  components: {
  },
  data() {
    return {
      parms: {
        pageNum: 1,
        pageSize: 10,
      },
      oList: [],
      total: 0,
    }
  },
  mounted() {
    this.getOrderList()
  },
  methods: {
    // 切换分页
    handleCurrentChange(val) {
      this.parms.pageNum = val
      this.getOrderList()
    },
    // 获取平仓订单列表
    async getOrderList() {
      this.parms.status = '3'
      const res = await orderApi.getOrderList(this.parms)
      this.oList = res.rows
      this.total = res.total
    },
    //复制方法
    onCopy(text) {
      return new Promise((resolve) => {
        if (navigator.clipboard?.writeText) {
          this.$toast(this.$t('public').copySuccess)
          return resolve(navigator.clipboard.writeText(text))
        }
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea)
        textarea.style.position = 'absolute'
        textarea.style.clip = 'rect(0 0 0 0)'
        textarea.value = text
        textarea.select()
        document.execCommand('copy', true)
        textarea.remove()
        this.$toast(this.$t('public').copySuccess)
        return resolve(true)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  margin-bottom: -60px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .title {
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
    }

    .listInfo {
      padding-bottom: 80px;
      margin-top: 30px;

      .item {
        padding: 15px;
        background: var(--info_color);
        border-radius: 10px;
        margin-top: 15px;

        .name {
          display: flex;
          justify-content: space-between;
          font-size: 20px;
          color: var(--text_color);
        }

        .time {
          margin-top: 10px;
          font-size: 15px;
          color: #64748B;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .order {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          font-size: 15px;
          color: #64748B;

          span {
            color: var(--primary_color);
          }
        }
      }

      .pagefoot {
        margin-top: 20px;
        text-align: right;
      }
    }
  }
}

// 分页
::v-deep .el-pagination button {
  color: var(--text_color);
  background-color: var(--background_color);
}

::v-deep .el-pager li {
  background: var(--background_color);
  color: var(--text_color);
}

::v-deep .el-pager li.active {
  color: #fff;
  background: var(--primary_color);
  border-radius: 15px;
}
</style>
